import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';

export function useScrollToHash() {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (!hash) return;

        const id = hash.startsWith('#') ? hash.slice(1) : hash;

        let attempts = 0;
        const maxAttempts = 20;

        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                el.focus();
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(tryScroll, 100);
            }
        };

        tryScroll();
    }, [location.hash]);
}
